import React from 'react';
import { Link } from 'react-router-dom';
import Button from './Button';
import Icon from './Icons';

const Hero = () => {
  return (
    <section className="relative overflow-hidden border-b border-border-subtle" aria-labelledby="hero-heading">
      <div className="absolute inset-0 bg-grid opacity-60" aria-hidden="true" />
      <div className="absolute -right-40 top-24 h-96 w-96 rounded-full bg-accent/10 blur-[120px]" aria-hidden="true" />
      <div className="container-app relative pt-24 pb-14 md:pt-32 md:pb-20 lg:pt-40 lg:pb-24">
        <div className="grid items-center gap-10 lg:grid-cols-[1.02fr_.98fr] lg:gap-16">
          <div className="max-w-2xl animate-fade-in-up">
            <div className="inline-flex items-center gap-2 rounded-full border border-accent/20 bg-accent-muted px-3 py-1.5 text-xs font-semibold uppercase tracking-[.12em] text-accent">
              <span className="h-1.5 w-1.5 rounded-full bg-accent animate-pulse-subtle" />
              Техника рядом · 24/7
            </div>
            <h1 id="hero-heading" className="mt-7 text-balance text-5xl font-semibold leading-[.98] tracking-[-.045em] text-text-primary sm:text-6xl lg:text-7xl">
              Спецтехника <span className="text-accent">без лишних звонков.</span>
            </h1>
            <p className="mt-6 max-w-xl text-base leading-7 text-text-secondary sm:text-lg">
              ТехАрена соединяет заказчиков и владельцев техники напрямую. Опишите задачу, получите подходящие варианты и запустите работу.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <Link to="/register"><Button variant="primary" size="xl" iconRight={<Icon name="arrowRight" />}>Начать работу</Button></Link>
              <Link to="/login"><Button variant="outline" size="xl">У меня уже есть аккаунт</Button></Link>
            </div>
            <div className="mt-8 flex flex-wrap gap-x-6 gap-y-2 text-xs text-text-tertiary">
              <span className="flex items-center gap-2"><Icon name="checkCircle" size={14} className="text-accent" /> Без посредников</span>
              <span className="flex items-center gap-2"><Icon name="shieldCheck" size={14} className="text-accent" /> Проверенные исполнители</span>
              <span className="flex items-center gap-2"><Icon name="clock3" size={14} className="text-accent" /> Доступно 24/7</span>
            </div>
          </div>

          <div className="relative animate-fade-in-up [animation-delay:120ms] mx-auto w-full max-w-md lg:max-w-none">
            {/* soft accent glow behind the floating render */}
            <div className="absolute inset-x-6 top-1/4 h-2/3 rounded-full bg-accent/15 blur-[90px]" aria-hidden="true" />
            <img
              src="/hero.webp"
              alt="Спецтехника: трактор, экскаватор, кран и самосвал"
              width={1100}
              height={688}
              loading="eager"
              fetchpriority="high"
              className="relative w-full [filter:drop-shadow(0_24px_48px_rgba(0,0,0,.45))]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};
export default Hero;
